<template>
    <div>
        <Hero />

        <div class="p-5 md:p-20">
            <div class="flex justify-center text-4xl font-bold">Pastor Ifeanyi Nwazuluoke</div>

            <div class="grid lg:grid-cols-2 mt-4">
                <div>
                    <img src="../assets//images/PASTOR.jpg" alt="Pastor Ifeanyi Nwazuluoke" class="w-full h-full rounded">
                </div>

                <div class="mt-5 lg:mt-0">
                    <div class="text-xl lg:mx-5 flex flex-col gap-5">
                        <p class="">The Saints Gathering Church is ably led by our Senior Pastor, Pastor Ifeanyi Sonna Nwazuluoke. Pastor Ifeanyi is a man of God whose heart burns with the fire of the Holy Ghost. His desire is for men to know God’s love for them and see their lives transformed by God’s word. He teaches God’s word in simplicity and demonstrations of the power of God.</p>

                        <img src="../assets/images/pastor_2.jpg" alt="Pastor Ifeanyi Nwazuluoke" class="rounded mt-2 lg:mt-7">
                    </div>
                </div>
            </div>

            <!-- <div class="mt-10">
                <div class="uppercase text-xl font-bold">follow his socials</div>

                <div class="grid grid-cols-2 py-4 text-4xl">
                    <div class="flex gap-2">
                        <a href="https://web.facebook.com/nwazuluoke.ifeanyisonna" target="_blank"><i class="fa-brands fa-facebook"></i></a>
                        <a href="https://twitter.com/SonnaIfeanyi" target="_blank"><i class="fa-brands fa-x-twitter"></i></a>
                        <a href="https://www.instagram.com/nwazuluokeifeanyi" target="_blank"><i class="fa-brands fa-instagram"></i></a>
                    </div>
                </div>
            </div> -->
        </div>

        <BecomeOurFamily />
        
        <BottomLinks />
    </div>
</template>

<script setup>
import Hero from '../components/Our_leadership/Hero.vue';
import BecomeOurFamily from '../components/BecomeOurFamily.vue'
import BottomLinks from '../components/Our_leadership/BottomLinks.vue';
</script>

<style scoped>

</style>